import { render, staticRenderFns } from "./CharacterList.vue?vue&type=template&id=68f3bf6a&scoped=true&"
import script from "./CharacterList.vue?vue&type=script&lang=js&"
export * from "./CharacterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f3bf6a",
  null
  
)

export default component.exports